export default "__VITE_ASSET__6105c238__"